import { combineReducers } from '@reduxjs/toolkit';
import { reducer as dashboardReducer } from '../slices/bitool';

const rootReducer = combineReducers({
  biTool: dashboardReducer,
});

export default rootReducer;
